<button mat-fab color="primary" (click)="openBottomSheet()" class="help-icon">
  <mat-icon fxFlexFill>contact_support</mat-icon>
</button>
